'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import './nprogress-custom-style.css';

export function LoadNProgressRouter() {
  const pathname = usePathname();

  useEffect(() => {
    const start = () => NProgress.start();

    const anchorClick = (e: MouseEvent) => {
      const a = (e.target as HTMLElement).closest('a');
      if (a?.href && a.origin === window.location.origin) {
        if (
          e.ctrlKey
          || e.metaKey
          || e.shiftKey
          || e.button !== 0
          || a.target === '_blank'
        ) {
          return;
        }

        const currentPath = pathname?.split('?')[0].replace(/\/$/, '') || '';
        const targetUrl = new URL(a.href);
        const targetPath = targetUrl.pathname.split('?')[0].replace(/\/$/, '');

        if (currentPath !== targetPath) {
          start();
        }
      }
    };

    document.addEventListener('click', anchorClick);

    return () => {
      document.removeEventListener('click', anchorClick);
    };
  }, [pathname]);

  useEffect(() => {
    NProgress.done();
  }, [pathname]);

  return null;
}
